import {ElevationApp} from "../ElevationApp";
import {DrawFrmThing, Disposable} from "../drawfrm/DrawFrmThing";
import {EventEmitter, Subscription} from "nate-react-api-helpers";
import {DimensionKind} from "../drawfrm/FrmShapeDimension";

export class ChildView {
    elev: ElevationApp;

    dimensionMode = new EventEmitter<DimensionKind | false>();

    private sceneAdd: AddFx;

    // arbitrary resources tied to this view's lifecycle, torn down in dispose()
    // (e.g. subscriptions, timers). Registered via track().
    private tracked: Disposable[] = [];

    constructor(elev: ElevationApp, add: AddFx) {
        this.elev = elev;
        this.sceneAdd = add;
        this.dimensionMode.emit("standard");
    }

    // add a thing to the scene, wiring any FrmShape dimensions it holds to this
    // view's showDetailedDimensions toggle so they hide/show together. fires
    // immediately with the current toggle value.
    add: AddFx = (item) => {
        this.sceneAdd(item);
    };

    // register a resource to be cleaned up when this view is destroyed.
    track<T extends Disposable>(input: T) {
        this.tracked.push(input);
        return input;
    }

    // register a subscription to be cancelled when this view is destroyed.
    // accepts either a nate-react-api-helpers Subscription (`.cancel()`) or a
    // plain unsubscribe function (as returned by the local EventEmitter2).
    trackSubscription(sub: Subscription | (() => void)) {
        this.track({
            destroy() {
                if (typeof sub === "function") sub();
                else sub.cancel();
            }
        });
    }

    destroy() {
        for (const item of this.tracked) {
            item.destroy();
        }

        this.tracked = [];
    }
}

export type AddFx = (item: DrawFrmThing) => void;